require('../stocksBuySellSummary/stocksBuySellSummary.scss');
require('./pensionPlanContributionSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const trim = require('lodash/string/trim');
const get = require('lodash/object/get');


// @helpers
const { formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @constants
const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    EURO_TEXT,
    BROKER_PLAN_PERIODICAL_CONTRIBUTION_SEGUN_IPC,
    HYPHEN
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class PensionPlanContributionSummary extends React.Component {

    constructor(props) {
        super(props);
    }

    buildValidityDateBlock() {
        const { step1 } = this.props;
        const validityDate = step1.get('validityDate');
        const formattedValidityDate =
            validityDate ?
                validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) :
                '-';

        return formattedValidityDate;
    }

    createInformativeListItem(title, value, value2) {
        return (
            <OKInformativeListItem
                title={title}
                columns={1}
                isUppercaseTitle={true}
                className="pension-plan-contribution-summary__stock-title"
            >
                <span className="pension-plan-contribution-summary__stock-container-info pension-plan-contribution-summary__stock-container-info--name">
                    {value} {value2}
                </span>
            </OKInformativeListItem>
        );
    }

    createLeftContainer(planContractNumber, walletPlan, planName) {
        return (
            <OKInformativeList>
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item1'), planContractNumber)}
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item2'), walletPlan.get('nombretitular'))}
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item3'), planName)}
            </OKInformativeList>
        );
    }

    createMiddleContainer(associatedAcount, amount, currency) {
        const amountFormatted = getFormattedString({
            amount: amount,
            currency: currency
        });
        return (
            <OKInformativeList>
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item4'), associatedAcount)}
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item5'), amountFormatted)}
            </OKInformativeList>
        );
    }

    createRightContainer(monthlyPeriodic, revAnual, initDate) {
        const itemInitDate = initDate ? this.createInformativeListItem(formatText('pensionPlanContribution-step2Item8'), initDate) : null;
        return (
            <OKInformativeList>
                {itemInitDate}
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item7'), monthlyPeriodic)}
                {this.createInformativeListItem(formatText('pensionPlanContribution-step2Item9'), revAnual)}
            </OKInformativeList>
        );
    }

    getRevAnual() {
        const { step1 } = this.props;
        const revAnual = step1.get('revAnual');
        const cleanRevAnual = trim(get(revAnual, 'tipoRetVal')).toUpperCase();
        const notRevAnual = formatText('pensionPlanPeriodicalContribution-noRevalOptionLabel').toUpperCase();

        if (revAnual === -1) {
            return HYPHEN;
        } else if (cleanRevAnual === BROKER_PLAN_PERIODICAL_CONTRIBUTION_SEGUN_IPC) {
            return formatText('pensionPlanPeriodicalContribution-ipcOptionLabel');
        } else if (revAnual.importeOPorcentajeRevalorización !== 0){
            return `${revAnual.importeOPorcentajeRevalorización}%`;
        } else {
            return notRevAnual;
        }
    }

    render() {
        const { planContractNumber, columns, plan, step1, walletPlan, planData, validationData, isEditMode } = this.props;

        let amount;
        let revAnual;
        let currency;
        let monthlyPeriodic;
        let rightContainer;
        if (step1.get('setPeriodicity')) {
            currency = (validationData ? validationData.get('codmonProd') : EURO_TEXT);
            amount = step1.get('periodiclyAmount');
            const monthlyPeriodicValue = step1.get('periodiclyMonthlyValue');
            monthlyPeriodic = step1.getIn(['periodiclyMonthlyOptions', monthlyPeriodicValue, 'label']);
            revAnual = this.getRevAnual();
            let initDate = !isEditMode ? this.buildValidityDateBlock() : null;
            
            rightContainer = (
                <div className={`col-lg-${columns}`}>
                    <div className="pension-plan-contribution-summary__titles-container-right">
                        {this.createRightContainer(monthlyPeriodic, revAnual, initDate)}
                    </div>
                </div>
            );
        } else {
            currency = planData ? planData.get('divisaDelMovimiento') : EURO_TEXT;
            amount = step1.get('originalAmount')
        }

        const planName = plan ? plan.get('Name') : '';
        const associatedAcount = walletPlan.getIn(['cuentaAsociada', 'oficina', 'entidad']) + walletPlan.getIn(['cuentaAsociada', 'oficina', 'oficina']) +
                                 walletPlan.getIn(['cuentaAsociada', 'digitodecontrol']) +  walletPlan.getIn(['cuentaAsociada', 'numerodecuenta']);

        return (
            <section className="pension-plan-contribution-summary__info-section row">
                <div className={`col-lg-${columns}`}>
                    <div className="pension-plan-contribution-summary__titles-container-left">
                        {this.createLeftContainer(planContractNumber, walletPlan, planName)}
                    </div>
                </div>
                <div className={`col-lg-${columns}`}>
                    {this.createMiddleContainer(associatedAcount, amount, currency)}
                </div>
                {rightContainer}
            </section>
        );
    }

}

PensionPlanContributionSummary.propTypes = {
    productName: PropTypes.string.isRequired,
    planContractNumber: PropTypes.string.isRequired,
    plan: PropTypes.object.isRequired,
    walletPlan: PropTypes.object.isRequired,
    planData: PropTypes.object.isRequired,
    validationData: PropTypes.object,
    step1: PropTypes.object.isRequired,
    step2: PropTypes.object,
    columns: PropTypes.number.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    modifier: PropTypes.oneOf([BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER, BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER]),
    maskLimitOrderType: PropTypes.bool.isRequired
};

PensionPlanContributionSummary.defaultProps = {
    columns: 5,
    maskLimitOrderType: false
};

module.exports = PensionPlanContributionSummary;
